import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';
import PageLoading from '../components/PageLoading';
import Business from 'material-ui/svg-icons/communication/business';
import right_corner_style from '../utils/right-corner-style';
import {List,ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import {orange500} from 'material-ui/styles/colors';

const businessColor = orange500;

export default
@observer class CustomersPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoNewCustomerPage() {
    this.context.router.push('/customers/newCustomer');
  }

  gotoCustomerDetailPage(customer) {
    return () => {
      this.context.router.push('/customers/edit/'+customer.id);
    }
  }

  infoLine(customer) {
    return [
      (customer.id_account ? uiMsg('CSP_ACCOUNT',"Account")+":"+customer.id_account : null),
      (customer.country_code ? uiMsg('CSP_COUNTRY',"Country")+":"+customer.country_code : null),
      (customer.segment ? uiMsg('CSP_SEGMENT',"Segment")+":"+customer.segment : null)
    ].filter(l=>!!l).join(", ")
  }

  render() {
    return (
      <PageLoading loading={AppModel.customerListLoading}>
        <List>
          {
            AppModel.customerList.map(c =>
              <ListItem
                  key={c.id}
                  value={c.id}
                  leftAvatar={<Avatar icon={<Business />}
                  backgroundColor={businessColor} />}
                  primaryText={c.name + " ("+c.id+")"}
                  secondaryText={this.infoLine(c)}
                  onTouchTap={this.gotoCustomerDetailPage(c)}
              />
          )
        }
      </List>


        {AppModel.canAddNewCustomers ?
            <FloatingActionButton style={right_corner_style}
                                children={<Add />}
                                onTouchTap={this.gotoNewCustomerPage.bind(this)} />
            :null
          }

      </PageLoading>

    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/CustomersPage.jsx
 **/